__turbopack_context__.v({
  "content": "DefaultTemplate-module-scss-module__eByUYW__content",
  "main": "DefaultTemplate-module-scss-module__eByUYW__main",
});
